import { useEffect } from 'react';
import useSubQuery from './useSubQuery.js';
import useWidget from './useWidget.js';
import { useHandlerRef } from './utils.js';
const useWidgetQuery = ({ active, onUpdate, ...props }) => {
    const deps = Object.entries(props).map(([, value]) => value);
    const { query: parentQuery } = useWidget();
    const onUpdateHandler = useHandlerRef(onUpdate, deps).current;
    const result = useSubQuery(parentQuery, (query) => {
        onUpdateHandler(query, props);
        query.setEnabled(active);
    });
    const { query, onParentUpdate, queryResult: { refetch, isFetched, isInitialLoading }, } = result;
    useEffect(() => {
        if (active && !query.isEnabled()) {
            // the query is ready to be enabled
            query.setEnabled(active);
        }
    }, [query, active]);
    useEffect(() => {
        // if it wasn't fetched yet, fetch it
        if (active && !isFetched && !isInitialLoading) {
            refetch();
        }
    }, [active, isFetched, isInitialLoading, refetch]);
    onParentUpdate((query, parentQuery) => {
        query.getRequest().load(parentQuery.getRequest());
        onUpdateHandler(query, props);
    });
    useEffect(() => {
        onUpdateHandler(query, props);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query, onUpdateHandler, ...deps]);
    return result;
};
export default useWidgetQuery;
